import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Dt6ResultBody from '../../../casinoComponents/refResultModal/Dt6ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

// Fallback modal titles (the modal shows the round's `ename` + " Result")
const TITLES = {
  dt6: '1 Day Dragon Tiger',
  pdt6: 'Premium 1 Day Dragon Tiger',
  tdt6: 'Tembo 1 Day Dragon Tiger',
  vdt6: 'V-1 Day Dragon Tiger',
};

/**
 * Last Result items for 1 Day Dragon Tiger (dt6 / pdt6 / tdt6 / vdt6) in the reference markup —
 * rendered inside `.casino-video-last-results` (reference LastResultsSection):
 *   win 1 → <span class="resulta">D</span>, 2 → <span class="resultb">T</span>, 0 → <span class="resulttie">T</span>
 * Click → full-page .loader-overlay while the round detail loads, then the reference result modal.
 */
const ResultDragonTiger6 = ({ data = [], gameType }) => {
  const apiType = (gameType || 'dt6').toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        if (response?.data?.data?.res) {
          setLastResults(response.data.data.res.map((item) => ({ mid: item.mid, win: String(item.win) })));
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (item) => {
    if (loading || !item?.mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, item.mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error fetching detail results:', error);
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  // API results; before they arrive, the feed's lrs ("D"/"T" or {mid, win}) as a fallback
  const items = lastResults.length > 0
    ? lastResults
    : (Array.isArray(data) ? data : []).map((r) =>
        typeof r === 'object' && r
          ? { mid: r.mid, win: String(r.win) }
          : { mid: null, win: r === 'D' ? '1' : r === 'T' ? '2' : String(r) }
      );

  return (
    <>
      {items.map((item, index) => {
        const cls = item.win === '1' ? 'resulta' : item.win === '2' ? 'resultb' : item.win === '0' ? 'resulttie' : undefined;
        return (
          <span key={item.mid || index} className={cls} onClick={() => handleResultClick(item)}>
            {item.win === '1' ? 'D' : null} {item.win === '2' ? 'T' : null} {item.win === '0' ? 'T' : null}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || TITLES[apiType] || TITLES.dt6} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Dt6ResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default ResultDragonTiger6;
